import { render, staticRenderFns } from "./InstrumentInstanceAdd.vue?vue&type=template&id=308696ec"
import script from "./InstrumentInstanceAdd.vue?vue&type=script&lang=js"
export * from "./InstrumentInstanceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports